import React from 'react';
import { finalCta, WHATSAPP_URL } from '../../content/siteContent';
import { StrokeIcon, WhatsAppIcon } from './Icons';

export default function CallToAction() {
  return (
    <section className="cta-final">
      <div className="cta-card">
        <span className="section-tag">{finalCta.tag}</span>
        <h2 className="cta-title">
          {finalCta.titleStart} <span className="text-accent">{finalCta.titleHighlight}</span>
        </h2>
        <p className="cta-text">{finalCta.text}</p>

        <div className="meeting-options">
          {finalCta.options.map((option) => (
            <div className="meeting-opt" key={option.label}>
              <StrokeIcon name={option.icon} size={18} />
              {option.label}
            </div>
          ))}
        </div>

        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="btn-gold btn-gold--cta">
          <WhatsAppIcon size={20} />
          <span>{finalCta.button}</span>
        </a>
      </div>
    </section>
  );
}
